// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3fhfo","box":"WorkspacesBox_box__16u37","node":"WorkspacesBox_node__a9roC"};